module.exports = __webpack_public_path__ + "img/elrond-avatar-dark.7a02f953.svg";